<template>
  <div>
    <!-- slider_area_start -->
    <div class="slider_area">
      <div
        class="single_slider d-flex align-items-center justify-content-center slider_bg_1 overlay2"
      >
         <div class="barberImg"><img src="../img/barbershopOwner.png" alt="Barbershop | salon de coiffure | صالون حلاقة" /></div>
        <div class="container">
          <div class="row">
            <div class="col-xl-12">
              <div class="slider_text text-center">
                <img src="../img/banner/barber_text.png" alt="Barbershop Agadir | salon de coiffure Agadir | صالون حلاقة" />
                <h3>
                  {{ $t("home.title1") }} <br />
                  {{ $t("home.title2") }}
                </h3>
                <p>{{ $t("home.subTitle") }}</p>
                  <div class="book_btn d-sm-block d-md-block  d-lg-none">
                    <a
                      @click="$store.commit('toggleActive')"
                      class="popup-with-form"
                      >{{ $t("nav.appointment") }}</a
                    >
                  </div>
              </div>
              
            </div>
     
          </div>
        </div>
      </div>
       <div class="wave-container" style="height: 150px; overflow: hidden;" ><svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;"><path d="M-6.20,4.45 C114.55,217.59 357.78,-112.00 500.00,49.98 L500.00,150.00 L0.00,150.00 Z" style="stroke: none; fill: #ffff;"></path></svg></div>
    </div>
    <About></About>
    <Service></Service>
    <Gallery></Gallery>
    <VideoSection></VideoSection>

    <Barbers></Barbers>
  </div>
</template>

<script>
import About from "./about.vue";
import Service from "./service.vue";
import Gallery from "./gallery.vue";
import VideoSection from "./layout/video-section.vue";
import Barbers from "./layout/barbers.vue";


export default {
  components: {
    About,
    Service,
    Gallery,
    VideoSection,
    Barbers,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/_responsive.scss";
@import "../styles/_mixins.scss";
@import "../styles/_varriable.scss";
@import "../styles/_reset.scss";
@import "../styles/_bradcam.scss";
@import "../styles/_btn.scss";
@import "../styles/_section_title.scss";



.wave-container{
    width: 100%;
    bottom: 83px;
    position: relative;
     @media #{$mobile_device} {
          height: 100px !important;
        }
}


.slider_bg_1 {
  background-image: url(../img/banner/banner.png);
    
}
.slider_area {
  max-height: 100vh;
  overflow: hidden;
  .single_slider {
    height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    @include center-element();
    .barberImg{
      position: absolute;
      width: 100%;
      display: flex;
      justify-content: end;
      align-items: flex-end;
      
      img{
        width: 980px;
        float: right;
        right: 0;
        opacity: 0.3;
        transform: translateX(8px);
        @media #{$big_device2} {
            width: 1400px;
        }
      }

    }

    .slider_text {
      h3 {
        color: #ffffff;
        font-family: $font1;
        font-size: 80px;
        text-transform: capitalize;
        letter-spacing: 2px;
        font-weight: 900;
        margin-bottom: 4px;
        margin: 20px 0 16px 0;
        line-height: 90px;
        @media #{$large_tablet} {
          font-size: 33px;
          letter-spacing: 3px;
          line-height: 40px;
        }
        @media #{$tablet_device} {
          font-size: 30px;
          line-height: 46px;
        }
        @media #{$mid_device} {
          font-size: 35px;
          line-height: 45px;
        }
      }
      p {
        font-size: 24px;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 0;
        margin-top: 0;
        display: inline-block;
        position: relative;
        &::before,
        &::after {
          position: absolute;
          background: #ffff;
          width: 50px;
          height: 1px;
          position: absolute;
          content: "";
          top: 50%;
        }
        &::before {
          left: 0;
          left: -70px;
        }
        &::after {
          right: -70px;
        }
        @media #{$mid_device} {
          font-size: 16px;
        }
        @media #{$mobile_device} {
          font-size: 16px;
        }
      }

      .book_btn{
        margin-top: 45px;
           a{
            background: transparent;
            font-size: 16px;
            font-weight: 400;
            border: 1px solid #fff;
            color: #fff;
            padding: 14px 20px;
        }
      }
    }
  }
}
</style>
